@if (deviceService.isNativePlatform) {
    <div class="top-safezone-offset" [style.height]="nativeSafeZoneService.paddings.top + 'px'"></div>
}
@if (viewNeedUpdateOverlay()) {
    <div class="phone-overlay need-update-overlay">
        <svg-icon class="version-check-bg" src="assets/img/version-check-bg.svg"></svg-icon>
        <svg-icon src="assets/icons/arrows-spin.svg"
            [svgStyle]="{ 'width.px':34, 'height.px':34}"
        ></svg-icon>
        <h2>{{ 'overlay.update.title' | translate }}</h2>
        <p>{{ 'overlay.update.text1' | translate }}</p>
        <p>{{ 'overlay.update.text2' | translate }}</p>

        <button class="update-btn" (click)="goToAppStore()">
            {{ 'overlay.update.button' | translate }}
        </button>
    </div>
} @else {
    @if (phoneNativeService.biometryLocked()) {
        <div class="phone-overlay biometry-locked-overlay">
            <div class="logo"></div>
        </div>
    }
    <router-outlet></router-outlet>
}